const HelloBar = () => (
  <div className="hellobar hellobarSpace barslideDown" id="helloBar">
    <div className="helloDiv text-center">
      <div className="hellobarContent">
        {/* BELL ICON */}
        <svg id="bell" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 47" width="20" height="20">
          <path
            id="bell-dome"
            className="st0"
            d="M35.8 16.8c0-5.7-3.7-10.5-8.9-12.2.1-.2.1-.4.1-.6 0-2.2-1.8-4-4-4s-4 1.8-4 4c0 .2 0 .4.1.6-5.2 1.7-8.9 6.5-8.9 12.2C10.2 30 3 30 3 36c0 1 0 3 20 3s20-2 20-3c0-6-7.2-6-7.2-19.2z"
            fill="url(#grad1)"
          />
          <defs>
            <clipPath id="clapper-mask">
              <path id="clapper-mask" d="M3 39v8h40v-8s-4 2.2-20 2.2S3 39 3 39z" />
            </clipPath>
            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop
                offset="0%"
                style={{
                  stopColor: 'rgb(245, 163, 76)',
                  stopOpacity: '1',
                }}
              />
              <stop
                offset="100%"
                style={{
                  stopColor: 'rgb(240, 200, 108)',
                  stopOpacity: '1',
                }}
              />
            </linearGradient>
          </defs>
          <defs></defs>

          <g clipPath="url(#clapper-mask)">
            <g id="clapper-group" className="st1">
              <circle id="clapper" className="st2" cx="23" cy="41" r="6" fill="rgb(254,0,122)" />
              <circle id="clapper-pivot" className="st3" cx="23" cy="4.5" r="35.5" fill="transparent" />
            </g>
          </g>
        </svg>
        {/* The Global Corporate Walkathon is back with season ✌️
                <b> Register for the event NOW!</b> */}
        <strong>Unlock your 2026 wellness strategy : &nbsp;</strong>
        Get our free calendar to plan impactful campaigns today.
      </div>
      <div className="hellobar-cta">
        <a id="hellobarbtn" href="https://www.vantagefit.io/vantagefit-wellness-campaigns/">
          Get Your Copy
        </a>
      </div>
    </div>
  </div>
)

export default HelloBar
